import Vue from 'vue'
import VueFlashMessage from 'vue-flash-message'

Vue.use(VueFlashMessage, {
    // method: 'iPreferQuickSilver',
    // props: {
    //     transitionName: 'fade',
    // },
    // transitionName: 'fade',
    messageOptions: {
        timeout: 8000,
    },
})

require('vue-flash-message/dist/vue-flash-message.min.css');

// VueFlashMessage.prop.transitionName = 'fade'